import { Component, HostBinding, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { IDynamicScreen } from '@mono-repo/data';
import { MessageService } from '@mono-repo/messages';
import { HeaderService } from '../../cockpit/_shared/header/header.service';
import { FormsUtilitiesService, MailingService2 } from '@mono-repo/complex-components';
import { TranslateService } from '@mono-repo/util';
import { PasswordValidation, FormHelperService } from '@mono-repo/complex-components';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
})
export class SetPasswordComponent extends PageContainer implements OnInit {
  @HostBinding('class') class = 'dt-c-interactive-dialog';

  public newPasswordScreen: IDynamicScreen;
  public newPasswordForm: FormGroup;
  private token: string;
  public errormsg;
  public pageSubheading: string;

  constructor(
    private router: Router,
    private messageService: MessageService,
    headerService: HeaderService,
    translateService: TranslateService,
    private mailingService2: MailingService2,
    private route: ActivatedRoute,
    private formsUtilitiesService: FormsUtilitiesService,
    private formHelperService: FormHelperService,
    private configService: ConfigService
  ) {
    super(headerService, translateService);
  }

  ngOnInit() {
    this.setTranslateModule('setPassword');
    this.pageSubheading = this.translateService.translate('PAGE_SUBHEADING');

    this.newPasswordScreen = {
      id: 'password',
      name: 'newPassName',
      fields: {
        results: [
          {
            id: 'password',
            dataTypeId: 'CHAR',
            label: this.translateService.translate('PASSWORD'),
            screenTypeId: '*',
            regex: '^(?=.*\\d)(?=.*[a-zA-Z])(?=.*\\W).{8,40}$',
            placeholder: this.translateService.translate('PASSWORD'),
            errorMessage: 'Das Passwort entspricht nicht den Anforderungen.',
            isRequired: true,
          },
          {
            id: 'confirmPassword',
            dataTypeId: 'CHAR',
            label: this.translateService.translate('CONFIRM_PASSWORD'),
            screenTypeId: '*',
            placeholder: this.translateService.translate('CONFIRM_PASSWORD'),
            isRequired: true,
          },
        ],
      },
    };

    // const formDescriptor = {};
    // formDescriptor[this.newPasswordScreen.id] =
    //   this.formHelperService.createFormGroupFromDynamicScreen(
    //     this.newPasswordScreen
    //   );
    // formDescriptor[this.newPasswordScreen.id].setValidators(
    //   PasswordValidation.matchPassword
    // );
    // this.newPasswordForm = new FormGroup(formDescriptor);
    this.newPasswordForm = this.formsUtilitiesService.createFormFromScreen(this.newPasswordScreen.fields.results);
    this.newPasswordForm.setValidators(PasswordValidation.matchPassword);

    this.errormsg = '';
    this.token = this.route.snapshot.paramMap.get('token');
  }

  public savePassword() {
    const password = this.newPasswordForm.value[this.newPasswordScreen.id];
    this.mailingService2.setNewPassword(this.token, password).subscribe(
      () => {
        this.router.navigateByUrl(`/${this.configService.getConfig().initialRoute}`);
      },
      () => {
        // error message is handled by odata service
        //this.messageService.add(error, MessageType.ERROR);
      },
    );
  }

  public cancelSetPassword() {
    this.router.navigateByUrl(`/${this.configService.getConfig().initialRoute}`);
  }
}
